import { render, staticRenderFns } from "./SuccessfulSubmissionView.vue?vue&type=template&id=7fdefa2c"
import script from "./SuccessfulSubmissionView.vue?vue&type=script&lang=js"
export * from "./SuccessfulSubmissionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports